var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import MuiChip from '@mui/material/Chip';
import { XClearCircleIcon } from '../../icons/XClearCircleIcon';
import React from 'react';
var statusStyle = {
    width: 8,
    height: 8,
    borderRadius: 30,
    padding: 0,
    marginLeft: 9,
    marginRight: 4,
};
var statusIcon = {
    active: (React.createElement("div", { style: __assign(__assign({}, statusStyle), { backgroundColor: designTokens.color.status.info.value }) })),
    inactive: (React.createElement("div", { style: __assign(__assign({}, statusStyle), { backgroundColor: designTokens.color.gray.limestone.value }) })),
    none: null,
};
var defaultProps = {
    color: 'primary',
    deleteIcon: React.createElement(XClearCircleIcon, null),
    status: 'none',
};
/**
 * Pigment [Chip](https://pigment.customink.com/?path=/docs/components-chip)
 */
var Chip = function (_a) {
    var _b, _c;
    var color = _a.color, deleteIcon = _a.deleteIcon, icon = _a.icon, status = _a.status, props = __rest(_a, ["color", "deleteIcon", "icon", "status"]);
    return (React.createElement(MuiChip, __assign({}, props, { deleteIcon: deleteIcon !== null && deleteIcon !== void 0 ? deleteIcon : defaultProps.deleteIcon, color: color !== null && color !== void 0 ? color : defaultProps.color, icon: (_c = (_b = statusIcon[status !== null && status !== void 0 ? status : defaultProps.status]) !== null && _b !== void 0 ? _b : icon) !== null && _c !== void 0 ? _c : React.createElement(React.Fragment, null) })));
};
export default Chip;
//# sourceMappingURL=Chip.js.map